import { render, staticRenderFns } from "./studentDetails.vue?vue&type=template&id=3389b751&scoped=true&"
import script from "./studentDetails.vue?vue&type=script&lang=js&"
export * from "./studentDetails.vue?vue&type=script&lang=js&"
import style0 from "./studentDetails.vue?vue&type=style&index=0&id=3389b751&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389b751",
  null
  
)

export default component.exports